<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.showInfo") }}</h4>
        </div>
        <div class="card-body">
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.identity") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <label>{{ studentCode }}</label>
                </div>
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.fullname") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <label>{{ displayName }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.educationLvl") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <label>{{ levelName }}</label>
                </div>
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.educationYear") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <label>{{ studentYear }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.faculty") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <label>{{ facultyName }}</label>
                </div>
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.department") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <label>{{ departmentName }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.educationCourse") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <label>{{ programName }}</label>
                </div>
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.consultants") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <label>{{ advisorName }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="text-center"
            style="border: 3px solid; border-radius: 10px;"
          >
            <v-sheet
              style="padding: 15px 0; color: red;"
              :height="height"
              color="yellow"
              ><strong>{{
                $t("messages.chkResultRequest.remark")
              }}</strong></v-sheet
            >
          </div>
          <br />
          <v-card>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("messages.general.seqOrder") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.classId") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.className") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.section") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.reason") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.chkResultRequest.reqPeriod") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.request") }}
                    </th>
                    <th class="text-center">
                      {{ $t("messages.general.resultApprove") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in data" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">
                      {{ item.COURSECODE }}
                    </td>
                    <td style="white-space: nowrap">
                      {{ item.COURSENAME }}
                    </td>
                    <td class="text-center">
                      {{ item.SECTION }}
                    </td>
                    <td style="white-space: nowrap">
                      {{ item.REASON }}
                    </td>
                    <td class="text-center">
                      {{ item.PRE_PERIOD }}
                    </td>
                    <td class="text-center">
                      {{ item.PRE_CONFIRM_STATUS }}
                    </td>
                    <td class="text-center">
                      {{ item.PRE_APPROVE_STATUS }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
          <br />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import PreEnrollProvider from "@/services/preEnroll_provider";

const preEnrollProvider = new PreEnrollProvider();

export default {
  name: "chkResultRequest",
  data: () => ({
    height: "auto",
    data: []
  }),
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      studentInfo: "getStudentInfo",
      studentId: "getStudentId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentUserId: function() {
      return _.isEmpty(this.studentInfo.data) ? this.userId : this.studentId;
    },
    studentCode: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERCODE_TXT
        : this.studentInfo.data.STUDENTCODE;
    },
    displayName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERNAME
        : `${this.studentInfo.data.PREFIXNAME} ${this.studentInfo.data.STUDENTNAME} ${this.studentInfo.data.STUDENTSURNAME}`;
    },
    levelName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.LEVELNAME
        : this.studentInfo.data.LEVELNAME;
    },
    studentYear: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.STUDENTYEAR
        : this.studentInfo.data.STUDENTYEAR;
    },
    facultyName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.FACULTYNAME
        : this.studentInfo.data.FACULTYNAME;
    },
    departmentName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.DEPARTMENTNAME
        : this.studentInfo.data.DEPARTMENTGROUPNAME;
    },
    programName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.PROGRAMNAME
        : this.studentInfo.data.PROGRAMNAME;
    },
    advisorName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.ADVISORNAME
        : this.studentInfo.data.ADVISORNAME;
    }
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    async loadData() {
      this.togglePreLoader(true);
      this.data = await preEnrollProvider.getApproveresult({
        token: this.token,
        request: {
          studentid: this.currentUserId,
          acadyear: this.appInfo.data.CURRENT_ACADYEAR,
          semester: this.appInfo.data.CURRENT_SEMESTER,
          lang: this.currentLang
        }
      });
      this.togglePreLoader(false);
    }
  },
  mounted() {
    this.tokenHealthChk();
    this.loadData();
  },
  watch: {
    currentLang() {
      this.loadData();
    }
  }
};
</script>

<style scoped>
.table-responsive table thead {
  /* background-image: linear-gradient(180deg, #54c4f0, #ef84d0) !important; */
  background-color: #ef84d0;
}
</style>
